import type { ISEOProps } from "../types/core";

export const SubscriptionsPageSEO: ISEOProps = {
  title: "Subscription Plans | Sugar Cribs",
  description:
    "Choose your subscription plan on Sugar Cribs. Freemium, Onyx, Sapphire, Diamond and Platinum VIP plans with different benefits and credits.",
};
